export default {
  text: '#111',
  primary: '#545454',
  secondary: '#000',
  background: '#ebebeb',
  backgroundSecondary: '#f7f7f7',
  light: '#545454',
  dark: '#111'
}
